import { type Technic } from '@rentguru/commons-utils';

export interface TechnicUpdate {
  technic: Technic;
  changes: Partial<Technic>;
  restore: Partial<Technic>;
}

type UpdateTechnic = (original: Technic, updates: Partial<Technic>) => Promise<Technic>;

/**
 * Applies every update and returns the updated technics; when one rejects, puts the successful ones back and rethrows
 * that rejection.
 */
export const updateTechnicsOrRestore = async (
  updates: TechnicUpdate[],
  updateTechnic: UpdateTechnic
): Promise<Technic[]> => {
  const results = await Promise.allSettled(updates.map(({ technic, changes }) => updateTechnic(technic, changes)));
  const rejectedUpdate = results.find((result) => result.status === 'rejected');
  if (rejectedUpdate?.status !== 'rejected') {
    return results.reduce<Technic[]>(
      (updatedTechnics, result) =>
        result.status === 'fulfilled' ? [...updatedTechnics, result.value] : updatedTechnics,
      []
    );
  }
  await Promise.allSettled(
    results.map((result, index) =>
      result.status === 'fulfilled' ? updateTechnic(result.value, updates[index].restore) : Promise.resolve(undefined)
    )
  );
  throw rejectedUpdate.reason;
};
